import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

export const getCaseRunHistory = async (id, tsrid, page = 1, filters = {}) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const url = new URL(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}`);

  url.searchParams.append("action", "getTestCaseHistoryForTestsuite");
  url.searchParams.append("companyid", user.companyid);
  url.searchParams.append("token", user.token);
  url.searchParams.append("testSuiteId", id);
  url.searchParams.append("testSuiteResultId", tsrid);
  url.searchParams.append("pnum", page);

  if (filters.filterOne) url.searchParams.append("filterOne", filters.filterOne);
  if (filters.filterTwo) url.searchParams.append("filterTwo", filters.filterTwo);
  if (filters.filterThree) url.searchParams.append("filterThree", filters.filterThree);

  const response = await axios.get(url.toString());
  return response.data;
};

export const useGetCaseRunHistory = (id, tsrid, page = 1, filters = {}, options = {}) => {
  return useQuery({
    queryFn: () => getCaseRunHistory(id, tsrid, page, filters),
    queryKey: ["getCaseRunHistory", id, tsrid, page, filters],
    staleTime: 0,
    refetchOnWindowFocus: false,
    ...options,
  });
};

export default useGetCaseRunHistory;
